/**
 * All the possible shape types for shape widgets in Dashboards
 */
const SHAPE_TYPE = {
	RECTANGLE: 'rectangle',
	ROUNDED_RECTANGLE: 'rounded-rectangle',
	ELLIPSE: 'ellipse',
	TRIANGLE: 'triangle',
	RIGHT_TRIANGLE: 'right-triangle',
	RIGHT_PARALLELOGRAM: 'right-parallelogram',
	LEFT_PARALLELOGRAM: 'left-parallelogram',
	TRAPEZOID: 'trapezoid',
	DIAMOND: 'diamond',
	PENTAGON: 'pentagon',
	HEXAGON: 'hexagon',
	OCTAGON: 'octagon',
	PLAQUE: 'plaque',
	PLUS: 'plus',
	STAR: 'star',
	SEAL: 'seal',
	CLOUD: 'cloud',
	CALLOUT: 'callout',
	PAGE: 'page',
	CYLINDER: 'cylinder',
	CUBE: 'cube',
	ARROW: 'arrow',
	DOUBLE_ARROW: 'double-arrow',
	QUAD_ARROW: 'quad-arrow',
	QUAD_BOX_ARROW: 'quad-box-arrow',
	DOUBLE_BOX_ARROW: 'double-box-arrow',
	BOX_ARROW: 'box-arrow',
	CHEVRON: 'chevron',
	RIGHT_CURVED_ARROW: 'right-curved-arrow',
	LEFT_CURVED_ARROW: 'left-curved-arrow',
	DOUBLE_CURVED_ARROW: 'double-curved-arrow',
	RIGHT_INWARD_UTURN_ARROW: 'right-inward-uturn-arrow',
	LEFT_INWARD_UTURN_ARROW: 'left-inward-uturn-arrow',
	RIGHT_OUTWARD_UTURN_ARROW: 'right-outward-uturn-arrow',
	LEFT_OUTWARD_UTURN_ARROW: 'left-outward-uturn-arrow',
	RIGHT_INWARD_FOLDED_ARROW: 'right-inward-folded-arrow',
	LEFT_INWARD_FOLDED_ARROW: 'left-inward-folded-arrow',
	RIGHT_OUTWARD_FOLDED_ARROW: 'right-outward-folded-arrow',
	LEFT_OUTWARD_FOLDED_ARROW: 'left-outward-folded-arrow',
	TAG: 'tag'
}

export {SHAPE_TYPE}